import api from './axios';

/**
 * Phase B — per-thread mute notifications API wrappers.
 */
export const listThreadMutesRequest  = ()          => api.get('/chat/thread-mutes');
export const storeThreadMuteRequest  = (threadId)  => api.post(`/chat/thread-mutes/${threadId}`);
export const deleteThreadMuteRequest = (threadId)  => api.delete(`/chat/thread-mutes/${threadId}`);
